/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { Fancybox } from "@fancyapps/ui";

/*------------------------------------*\
    MODAL GALLERY
\*------------------------------------*/
class ModalGallery {
    constructor(passedElement) {
        this.elem = passedElement;
    }

    init() {
        if (this.elem.querySelector('[zoomed-img]')) {
            Fancybox.bind(this.elem, '[zoomed-img]');
        }

        if (this.elem.querySelector('[data-fancybox]')) {
            Fancybox.bind(this.elem, '[data-fancybox]');
        }
    }
}

export default ModalGallery;